/* eslint-disable import/no-extraneous-dependencies */
import i18n from 'lib/i18n'

const translate = i18n('office')

export default translate



// WEBPACK FOOTER //
// ./components/office/translation.js